<mat-card>
  <mat-card-header class="container between mb-1">


    <h4 matCardTitle>Töiden luokittelu, kohteessa
      @if (project | async; as currentProject) {
        @if (currentProject) {
          <span>{{ currentProject.name }}</span>
        }
        @if (!currentProject) {
          <span><mat-icon>account_tree</mat-icon></span>
        }
      }

    </h4>
    <h6 matCardSubtitle>Nämä vaihtoehdot käytettävissä työtuntien kirjauslomakkeella tarkentamaan raportointia</h6>
    <!-- <div>

    <mat-card-subtitle>
      Alla kirjaustarkennukset työmaalle {{ (project|async)?.name }}
    </mat-card-subtitle>
  </div> -->

  <div class="container">

    <button mat-raised-button class="btn-secondary" (click)="exportTreeToPDF()" [disabled]="classifications.length === 0 || isExporting">
      <mat-icon>picture_as_pdf</mat-icon>
      {{ 'WORKCLASSIFICATION.EXPORTPDF' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="addSubClassification(null)"><mat-icon>add</mat-icon> Lisää uusi</button>
    <button mat-raised-button color="primary" (click)="copyAllClassifications()"><mat-icon>content_copy</mat-icon> Kopioi toiselle työmaalle</button>
  </div>



</mat-card-header>
<mat-card-content>

  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <!-- This node is used for non-expandable nodes -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [attr.data-id]="node.id" [class.highlighted]="nodeStates[node.id] === 'highlighted'">
      <button mat-icon-button disabled></button>
      <div class="node-container">

        <div class="tree-node-title" matTreeNodeToggle [ngClass]="{'CAPS':node.parentClassificationId==0}">

          {{ node.name }}
        </div>
        <div class="tree-node-subtitle faint">
          {{ node.description }}
        </div>
      </div>
      <div class="icon-button-group">
        <button mat-icon-button mat-medium-icon-button color="primary" (click)="addSubClassification(node)">
          <mat-icon class="icon-sm">add</mat-icon>
        </button>
        <button  *hasPermission="permissions.WorkClassificationPermissions.CanEditWorkClassification" mat-icon-button  mat-medium-icon-button color="primary" class="faint" (click)="editClassification(node)">
          <mat-icon class="icon-sm">edit</mat-icon>
        </button>
        @if (node.children.length <1) {
          <button *hasPermission="permissions.WorkClassificationPermissions.CanDeleteWorkClassification" mat-icon-button  mat-medium-icon-button color="warn" (click)="deleteClassification(node)">
            <mat-icon class="icon-sm">delete</mat-icon>
          </button>
        }
      </div>
    </mat-tree-node>

    <!-- This node is used for expandable nodes -->
    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding [attr.data-id]="node.id" [class.highlighted]="nodeStates[node.id] === 'highlighted'">
      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
      <div class="node-container">

        <div class="tree-node-title" matTreeNodeToggle [ngClass]="{'CAPS':node.parentClassificationId==0}">

          {{ node.name }}
        </div>
        <div class="tree-node-subtitle faint">
          {{ node.description }}
        </div>
      </div>
      <div class="icon-button-group">
        <button mat-icon-button mat-medium-icon-button color="primary" (click)="addSubClassification(node)">
          <mat-icon class="icon-sm">add</mat-icon>
        </button>
        <button  *hasPermission="permissions.WorkClassificationPermissions.CanEditWorkClassification" mat-icon-button  mat-medium-icon-button color="primary" class="faint" (click)="editClassification(node)">
          <mat-icon class="icon-sm">edit</mat-icon>
        </button>
        @if (node.children.length <1) {
          <button *hasPermission="permissions.WorkClassificationPermissions.CanDeleteWorkClassification" mat-icon-button  mat-medium-icon-button color="warn" (click)="deleteClassification(node)">
            <mat-icon class="icon-sm">delete</mat-icon>
          </button>
        }
      </div>
    </mat-tree-node>
  </mat-tree>

</mat-card-content>
</mat-card>
